// extracted by mini-css-extract-plugin
module.exports = {"alerts":"styles_alerts__mXWFF","alertTable":"styles_alertTable__1uzNw"};